/**
 * Available PR tab values
 */
export type PRTabValue = 'discussion' | 'changes' | 'diff-beta';

/**
 * Constant map of PR tab values for consistent usage across components
 */
export const PR_TABS = {
  DISCUSSION: 'discussion' as const,
  CHANGES: 'changes' as const,
  DIFF_BETA: 'diff-beta' as const,
} as const;
